import axios from '../../config/axios.js'

const STATE = {
    error_code: null,
    dialog: false,
}

const GETTERS = {
    error_code: state => state.error_code,
    dialog: state => state.dialog,
}

const MUTATIONS = {

    setErrorCode(state, code) {
        state.error_code = code
    },

    setDialog(state, status) {
        state.dialog = status
    },

}

export default {
    namespaced: true,
    state: STATE,
    getters: GETTERS,
    mutations: MUTATIONS,
    // actions: ACTIONS,
}


// WEBPACK FOOTER //
// ./src/vuex/modules/error.js